(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory();
	else if(typeof define === 'function' && define.amd)
		define("twc", [], factory);
	else if(typeof exports === 'object')
		exports["twc"] = factory();
	else
		root["twc"] = factory();
})(window, function() {
return 